import { lazy } from "react"

export const SalesAnalyticsPage = lazy(() => import("./SalesAnalyticsPage"))
